import * as React from 'react';
export const IcFlash = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.59 12.18l7.7-9.62A1.48 1.48 0 0115.83 4l-2 5.48h2.67a2 2 0 011.51 3.24l-7.37 8.75A1.48 1.48 0 018.16 20l1.77-4.6h-2.8a2 2 0 01-1.54-3.22z'
      fill='currentColor'
    />
  </svg>
);
